module.exports = __webpack_public_path__ + "static/media/0035.795c37f8.png";